import { Box, useMediaQuery } from '@chakra-ui/react';
import {
  bindPromoData,
  OrderDetailData,
  OrderDetailDataWithDivider,
} from '@diamond/sol-buyer/utils';
import { useFormContext } from 'react-hook-form';

import { MobileProductTable, ProductTable } from '../common';

type PartialFormValues = {
  items: OrderDetailData;
  is_submitted: boolean;
};

export function ProductDetails() {
  const { getValues } = useFormContext<PartialFormValues>();
  const [isMobile] = useMediaQuery('(max-width: 768px)');

  const items = getValues('items') ? getValues('items') : [];

  const data: OrderDetailDataWithDivider = items
    ?.filter((item) => item.products.length !== 0)
    .map(({ division, ...rest }) => ({
      divider: division === 'fnb' ? 'fine food' : division,
      ...rest,
    }));

  const dataWithPromo = bindPromoData(data);
  const isSubmitted = getValues('is_submitted');

  return (
    <Box
      flex="1"
      border={{ base: 'unset', md: '1px' }}
      borderColor={{ base: 'unset', md: 'gray.33' }}
      shadow={{ base: 'unset', md: 'base' }}
      px={{ base: 'unset', md: '0' }}
      py={{ base: 'unset', md: '8' }}
      rounded="lg"
    >
      {isMobile ? (
        <MobileProductTable data={dataWithPromo} isSubmitted={isSubmitted} />
      ) : (
        <ProductTable data={dataWithPromo} isSubmitted={isSubmitted} />
      )}
    </Box>
  );
}
